import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../../components/common/HeroSection';
import SEO from '../../components/seo/SEO';
import BusinessSchema from '../../components/seo/BusinessSchema';

const Services = () => {
  const services = [
  {
    id: 1,
    title: "Kilo Yönetimi",
    description:
      "Vücut tipinize, yaşam tarzınıza ve hedeflerinize uygun kapsamlı kilo yönetimi programları. Sağlıklı beslenme alışkanlıklarını öğrenin ve sürdürülebilir başarı için stratejiler geliştirin.",
    icon: (
      <svg
        className="w-10 h-10 text-nihal-primary"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13 10V3L4 14h7v7l9-11h-7z"
        ></path>
      </svg>
    ),
  },
  {
    id: 2,
    title: "Hastalıklarda Beslenme",
    description:
      "Hipertansiyon, böbrek hastalıkları, karaciğer hastalıkları, tiroid sorunları gibi durumlarda özel diyet planları.",
    icon: (
      <svg
        className="w-10 h-10 text-nihal-primary"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        ></path>
      </svg>
    ),
  },
  {
    id: 3,
    title: "Çocuk ve Ergen Beslenmesi",
    description:
      "Büyüme ve gelişmeyi destekleyen, sağlıklı alışkanlıklar kazandıran beslenme programları.",
    icon: (
      <svg
        className="w-10 h-10 text-nihal-primary"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
    ),
  },
  {
    id: 4,
    title: "Sindirim Sağlığı",
    description:
      "Sindirim sağlığınızı iyileştirmeye yönelik kişiselleştirilmiş planlar. Tetikleyici gıdaları belirleyin, onarıcı besinleri dahil edin ve bağırsak sağlığını destekleyen beslenme düzenleri oluşturun.",
    icon: (
      <svg
        className="w-10 h-10 text-nihal-primary"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
        ></path>
      </svg>
    ),
  },
  {
    id: 5,
    title: "Sporcu Beslenmesi",
    description:
      "Bilimsel temelli beslenme stratejileriyle sportif performansınızı optimize edin. Antrenman, yarışma ve toparlanma dönemleri için kişiselleştirilmiş beslenme planları hazırlayın.",
    icon: (
      <svg
        className="w-10 h-10 text-nihal-primary"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13 10V3L4 14h7v7l9-11h-7z"
        ></path>
      </svg>
    ),
  },
  {
    id: 6,
    title: "Gebe ve Emzirme Dönemi Beslenmesi",
    description:
      "Hamilelik ve emzirme sürecinde anne ve bebeğin sağlığını destekleyen beslenme planları.",
    icon: (
      <svg
        className="w-10 h-10 text-nihal-primary"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
        ></path>
      </svg>
    ),
  },
];

  return (
    <div className="w-full">
      <SEO 
        title="Diyetisyen Nihal Kamış - Beslenme Danışmanlığı ve Diyet Programları | İstanbul"
        description="İstanbul merkezli diyetisyen Nihal Kamış'tan kilo yönetimi, hastalıklarda beslenme, çocuk ve ergen beslenmesi, sindirim sağlığı, sporcu beslenmesi ve gebe dönem beslenmesi hizmetleri."
        url="https://www.dytnihalkamis.com/services"
        keywords="diyetisyen hizmetleri, beslenme danışmanlığı, kilo yönetimi, hastalıklarda beslenme, çocuk beslenmesi, sporcu beslenmesi, gebe beslenmesi"
      />
      <BusinessSchema />
      
      {/* Page Header */}
      <HeroSection 
        title="Hizmetlerimiz" 
        subtitle="Sağlık hedeflerinize yönelik kişiselleştirilmiş beslenme rehberliği" 
      />

      <div className="section-padding bg-white">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-nihal-dark mb-4">Beslenme Hizmetleri</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
             Benzersiz sağlık ihtiyaçlarınıza ve hedeflerinize uygun kapsamlı beslenme hizmetleri sunuyorum.
			Her hizmet, kişiye özel rehberlik ve sürekli destek içermektedir.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {services.map((service) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: service.id * 0.1 }}
                className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition-shadow border border-gray-100"
              >
                <div className="w-16 h-16 bg-nihal-secondary rounded-full flex items-center justify-center mb-6">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-nihal-dark mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </motion.div>
            ))}
          </div>

          {/* Service Process */}
          <div className="bg-nihal-secondary rounded-2xl p-8 md:p-12 mb-16">
            <h2 className="text-3xl font-bold text-nihal-dark text-center mb-12">Süreçte Nasıl İlerliyoruz?</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4, delay: 0.1 }}
    className="text-center"
  >
				<div className="w-20 h-20 bg-nihal-primary rounded-full flex items-center justify-center mx-auto mb-6">
				<span className="text-white text-2xl font-bold">1</span>
				</div>
				<h3 className="text-xl font-bold text-nihal-dark mb-3">Ön Görüşme</h3>
				<p className="text-gray-700">
				Sağlık hedeflerinizi, tıbbi geçmişinizi ve yaşam tarzınızı konuşarak size özel ihtiyaçları belirliyoruz.
				</p>
			</motion.div>
			
			<motion.div
				initial={{ opacity: 0, y: 30 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.4, delay: 0.2 }}
				className="text-center"
			>
				<div className="w-20 h-20 bg-nihal-primary rounded-full flex items-center justify-center mx-auto mb-6">
				<span className="text-white text-2xl font-bold">2</span>
				</div>
				<h3 className="text-xl font-bold text-nihal-dark mb-3">Kişiye Özel Plan</h3>
				<p className="text-gray-700">
				Beslenme alışkanlıklarınıza, hedeflerinize ve tercihlerinize uygun özel bir beslenme planı oluşturuyorum.
				</p>
			</motion.div>
			
			<motion.div
				initial={{ opacity: 0, y: 30 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true }}
				transition={{ duration: 0.4, delay: 0.3 }}
				className="text-center"
			>
				<div className="w-20 h-20 bg-nihal-primary rounded-full flex items-center justify-center mx-auto mb-6">
				<span className="text-white text-2xl font-bold">3</span>
				</div>
				<h3 className="text-xl font-bold text-nihal-dark mb-3">Sürekli Destek</h3>
				<p className="text-gray-700">
				Düzenli takiplerle ilerlemenizi izliyor, gerekli düzenlemeleri yapıyor ve sürekli rehberlik sağlıyorum.
				</p>
			</motion.div>
			</div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <h2 className="text-3xl font-bold text-nihal-dark mb-6">Sağlığınızı Dönüştürmeye Hazır mısınız?</h2>
            <p className="text-gray-600 max-w-2xl mx-auto mb-8">
             Her adımda size özel bir beslenme yolculuğu.
            </p>
            <a 
              href="/contact" 
              className="btn btn-primary text-lg px-8 py-4"
            >
              Bir Görüşme Planla
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;